import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import SectionTitle from "../components/sectionTitle/SectionTitle";
import FooterOne from "../common/footer/FooterOne";
import SEO from "../common/SEO";
import BreadcrumbOne from "../common/breadcrumb/BreadcrumbOne";
import Layout from "../common/Layout";

const PartnerProgram = (props) => {
  const isHomePage = window.location.pathname === "/";
  return (
    <Layout>
      {!isHomePage && <SEO title="Pályázzon velünk!" />}
      {false && (
        <BreadcrumbOne
          style={{
            backgroundImage: `url('https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/delivery-module-banner.jpg')`,
          }}
          title={"<font style='color: white'>Partnerprogram</font>"}
          rootUrl="/"
          parentUrl={"<font style='color: white'>Partnerprogram</font>"}
        />
      )}

      <div className="col-lg-12" style={{ marginBottom: "2rem" }}>
        <div className="inner">
          <img src={"https://images.happysolutions.hu/palyazat-header.jpg"} alt="Pályázzon velünk!"/>
        </div>
        <div className="col-lg-12">
          <div className="inner">
            <div className="col-lg-12 content text-start">
              <h1 className="title">Pályázati fejlesztés? Válassza a Happy Solutions rendszert!</h1>
              <p className="description" style={{fontSize: 18}}>
                Ha vállalkozása a következő pályázatok valamelyikén indul, érdemes már most olyan rendszert választani, amely valódi működési előnyt és hosszú távú stabilitást ad!
              </p>
              <div className="btn-area" style={{display: "flex", gap: 16, flexWrap: "wrap"}}>
              <button className="edu-btn"
                  onClick={() => {
                  document.getElementById("footer-kapcsolat")?.scrollIntoView({ behavior: "smooth" });
                }}>
                  Keressen bennünket bizalommal!
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="edu-about-area about-style-3 edu-section-gap bg-image">
        <div className="container eduvibe-animated-shape">
          <div className="row g-5">
            <div className="col-12" id={"delivery-module"}>
              <div className="row inner justify-content-center align-items-center d-flex">
                <div className="col-lg-8">
                  <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}
                    style={{ paddingRight: 40 }}
                  >
                    <h2>Lépjen szintet vállalkozásával – akár 70% támogatással!</h2>
                    <p className="description mt--40">
                      Most itt az esély, hogy a <b>GINOP Plusz, DIMOP Plusz, a Hitelprogram vagy a Demjén Sándor 1+1 – KKV
                      Beruházás-élénkítő Támogatási Program</b> segítségével modern ERP rendszert vezessen be – jelentős
                      állami támogatással.
                      </p>
                    <p>
                      A pályázatok célja a hazai KKV-k digitalizációjának és innovációs képességének erősítése. A Happy
                      Solutions rendszeresi ehhez kínál <b>valódi</b>, működésben is bizonyított <b>megoldást.</b>
                    </p>
                    <h3>Miért érdemes most pályázni?</h3>
                      <ul className="happy-module-list">
                        <li>Akár 70% vissza nem térítendő támogatás</li>
                        <li>3–50 millió Ft támogatási összeg</li>
                        <li>0%-os kamatozású kölcsön, akár 8 éves futamidővel</li>
                        <li>Teljes körű pályázatírási és megvalósítási támogatás</li>
                        <li>Pályázati garancia – minimum 30% vissza nem térítendő támogatás</li>
                      </ul>
                    <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }} aria-label="Konzultációt kérek">
                      Keresse kollégánkat ingyenes konzultációval!
                    </button>
                  </ScrollAnimation>
                </div>
                <div className="col-lg-4 d-flex justify-content-center align-items-start">
                  <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOutUp"
                    className="testimonial-left-image"
                    animateOnce={true}
                  >
                    <div className="thumbnail">
                      <div
                        className="circle-image-wrapper"
                        style={{ width: "48rem" }}
                      >
                        <img
                          style={{
                            width: "44rem",
                            height: "44rem",
                            objectFit: "cover",
                            verticalAlign: "right !important;"
                          }}
                          className="radius-round"
                          src="https://images.happysolutions.hu/palyazat.jpg"
                          alt="Pályázzon velünk!"
                        />
                        <div className="circle-image">
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
            <div className="col-12" id={"delivery-module"} style={{ paddingTop: 40 }}>
              <h2>Digitalizáljon támogatással!</h2>
              <p>
                A Happy Solutions ERP rendszer <b>egyetlen platformon, valós időben biztosítja a legfontosabb üzleti adatokat</b>, így átláthatóbb működést és gyorsabb vezetői döntéshozatalt tesz lehetővé.
              </p>
              <p>
                <b>Ne csak pályázzon – fejlessze is vállalkozását</b> a Happy Solutions moduláris ERP, CRM, kereskedelmi, szolgáltatási rendszerével!
              </p>
              <p>
                <b>Vegye fel velünk a kapcsolatot</b>, és nézzük meg, milyen támogatással valósítható meg az ERP bevezetése az Ön cégénél!
              </p>
            </div>
          </div>
          <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
            <div className="shape-image shape-image-1">
              <img src="/images/shapes/shape-21.png" alt="Shape Thumb" />
            </div>
            <div className="shape-image shape-image-2">
              <img src="/images/shapes/shape-13-04.png" alt="Shape Thumb" />
            </div>
            <div className="shape-image shape-image-3">
              <img src="/images/shapes/shape-03-05.png" alt="Shape Thumb" />
            </div>
            <div className="shape-image shape-image-4">
              <img src="/images/shapes/shape-15-02.png" alt="Shape Thumb" />
            </div>
          </div>
        </div>
      </div>

      <a id="footer-kapcsolat"></a>
      {!isHomePage && <FooterOne />}
    </Layout>
  );
};

export default PartnerProgram;
